import { gql } from "@apollo/client";

export const GET_VERSION = gql`
	query GetVersion {
		version {
			name
			version
		}
	}
`;

export const GET_WALLET = gql`
  query GetWallet($address: String!) {
    wallet(address: $address) {
      address
      created
      referee
      referee_id
      staked
      safary_id
      claimr_id
      confirmed
      user_id
      vaults {
        name
        title
        address
        logo
        estimated_performance
        strategy
        transactions {
          trxn_type
          amount_brkt
        }
        manager {
          address
          created
          confirmed
        }
        manager_address
        consumers {
          address
          created
          confirmed
        }
        amount_available
        close_date
        fee_method
      }
      managed_vaults {
        name
        title
        address
        logo
        estimated_performance
        strategy
        manager {
          address
          created
          confirmed
        }
        manager_address
      }
      transactions {
        created
        token
        chain
        block
        amount
        amount_eq
        amount_brkt
        wallet_address
        type
        scheduled_withdraw_time
        claimed_withdraw_time
        claimed
      }
      escrow {
        chain
        block
        created
        token
        amount
        type
        wallet_address
      }
    }
  }
`;

export const GET_USER = gql`
  query GetUser($email: String!) {
    user(email: $email) {
      id
      email
      wallets {
        address
        created
        referee
        referee_id
        staked
        confirmed
      }
    }
  }
`;

export const BRKT_TRANSACTIONS_QUERY = gql`
	query GetBrktTransactions($wallet: String!) {
		checkin(wallet: $wallet) {
			address
			transactions {
				created
				token
				amount
				amount_eq
				amount_brkt
				type
				scheduled_withdraw_time
				claimed_withdraw_time
				claimed
				salt
			}
		}
	}
`;

export const CHECKIN_QUERY = gql`
  query Checkin($wallet: String!) {
    checkin(wallet: $wallet) {
      address
      escrow {
        chain
        token
        amount
        type
      }
      claim {
        amount
        claimed
        proof
      }
      claim_detail {
        token
        amount
        claimed
        proof
      }
    }
  }
`;

export const GET_KYC = gql`
  query GetKyc($address: String!) {
    wallet(address: $address) {
      user {
        kyc_status
        kyc_reason
        email
      }
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query GetNotification {
    notifications {
      id
      created
      status
      recipient
      vault_address
      title
      body
      icon
      action_url
      action_label
    }
  }
`;

export const GET_VAULT_TRANSACTIONS = gql`
  query GetVaultTransactions($address: String!) {
    wallet(address: $address) {
      vaults {
        name
        address
        transactions {
          trxn_type
          amount_brkt
        }
      }
    }
  }
`;

export const GET_DASHBOARD_DATA = gql`
  query GetDashboardData {
    platform {
      pnl {
        brkt
        usd
      }
      current {
        brkt
        usd
      }
      tvl {
        brkt
        usd
      }
      invested {
        brkt
        usd
      }
      brkt {
        eth
        usd
      }
      balance {
        brkt
        usd
      }
      strategies {
        brkt
        usd
      }
      points
    }
  }
`;

export const GET_TRANSACTION_LOGS = gql`
	query GetTransactionLogs {
		transaction_log {
			created
			type
			trxn_type
			sub_type
			shares
			nav
			status
			symbol
			amount {
				brkt
				usd
			}
			scheduled_time
			claimed_time
			epoch_available
			denomination {
				decimals
				symbol
				label
			}
		}
	}
`;


export const GET_PROFILE = gql`
	query GetProfile($address: String!) {
		wallet(address: $address) {
			address
			user {
				name
				nickname
				email
			}
		}
	}
`;

export const GET_BRKT_PRICE_HISTORY = gql`
	query GetBrktPriceHistory($start: String!, $end: String!) {
		brkt_price_history(start: $start, end: $end) {
			conv_rate
			eth_price
			brkt_eth_price
			brkt_supply
			total_value
			date
		}
	}
`;
